// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f6e61fcb","784":"4389ba39","977":"c5d62774"}[chunkId] + ".chunk.js";
};